"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
function JetBanner() {
    var _a, _b;
    var _c = (0, react_1.useState)(true), show = _c[0], setShow = _c[1];
    var props = (0, inertia_react_1.usePage)().props;
    var style = ((_a = props.jetstream.flash) === null || _a === void 0 ? void 0 : _a.bannerStyle) || 'success';
    var message = ((_b = props.jetstream.flash) === null || _b === void 0 ? void 0 : _b.banner) || '';
    return (react_1.default.createElement("div", null, show && message ? (react_1.default.createElement("div", { className: (0, classnames_1.default)({
            'bg-indigo-500': style == 'success',
            'bg-red-700': style == 'danger',
        }) },
        react_1.default.createElement("div", { className: "max-w-screen-xl mx-auto py-2 px-3 sm:px-6 lg:px-8" },
            react_1.default.createElement("div", { className: "flex items-center justify-between flex-wrap" },
                react_1.default.createElement("div", { className: "w-0 flex-1 flex items-center min-w-0" },
                    react_1.default.createElement("span", { className: (0, classnames_1.default)('flex p-2 rounded-lg', {
                            'bg-indigo-600': style == 'success',
                            'bg-red-600': style == 'danger',
                        }) }, (function () {
                        switch (style) {
                            case 'success':
                                return (react_1.default.createElement("svg", { className: "h-5 w-5 text-white", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                                    react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" })));
                            case 'danger':
                                return (react_1.default.createElement("svg", { className: "h-5 w-5 text-white", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                                    react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" })));
                            default:
                                return null;
                        }
                    })()),
                    react_1.default.createElement("p", { className: "ml-3 font-medium text-sm text-white truncate" }, message)),
                react_1.default.createElement("div", { className: "flex-shrink-0 sm:ml-3" },
                    react_1.default.createElement("button", { type: "button", className: (0, classnames_1.default)('-mr-1 flex p-2 rounded-md focus:outline-none sm:-mr-2 transition', {
                            'hover:bg-indigo-600 focus:bg-indigo-600': style == 'success',
                            'hover:bg-red-600 focus:bg-red-600': style == 'danger',
                        }), "aria-label": "Dismiss", onClick: function (e) {
                            e.preventDefault();
                            setShow(false);
                        } },
                        react_1.default.createElement("svg", { className: "h-5 w-5 text-white", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                            react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M6 18L18 6M6 6l12 12" })))))))) : null));
}
exports.default = JetBanner;
